import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const SortIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M9.05 12.1V4.65L5.8 7.9l-.5-.5 4.1-4.1 4.1 4.1-.5.5-3.25-3.25v7.45h-.7Zm5.525 8.6-4.1-4.1.5-.5 3.25 3.25V11.9h.7v7.45l3.25-3.25.5.5-4.1 4.1Z"
            />
        </svg>
    </IconWrapper>
));
